// extracted by mini-css-extract-plugin
module.exports = {"container":"MapCoordinates_container__FjwrR","elevation":"MapCoordinates_elevation__JK_vX"};